<template>
  <v-content v-if="quote">
    <Header :title="heading" />
    <v-container>
      <v-card v-if="quoteProperties">
        <v-card-text>
          <p>
            {{ quoteProperties.salesClient1 }}
            <span style="font-weight: bold; font-size: 1.5em">{{
              $route.params.quoteId
            }}</span>
          </p>
          <p>{{ quoteProperties.salesClient3 }}</p>
          <p>
            {{ quoteProperties.salesClient4 }}
            {{ quoteProperties.salesClient5 }}
            {{ quoteProperties.salesClient6 }}
          </p>
          <p>{{ quoteProperties.salesClient7 }}</p>
          <p>
            <span style="font-weight: bold; font-size: 1.5em">
              <a :href="`tel:${quoteProperties.salesClient8}`">{{
                quoteProperties.salesClient8
              }}</a>
            </span>
            {{ quoteProperties.salesClient9 }}
            <span style="font-weight: bold; font-size: 1.5em">
              <a :href="`mailto:${quoteProperties.salesClient10}`">{{
                quoteProperties.salesClient10
              }}</a>
            </span>
          </p>
          <ProceedButton @clicked="proceed()" @callback="callback()" />
        </v-card-text>
      </v-card>
      <v-card v-if="quoteHtml">
        <v-card-text v-html="quoteHtml" />
      </v-card>
      <v-card>
        <v-card-text>
          <ProceedButton @clicked="proceed()" @callback="callback()" />
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import Header from "@/components/Header";
import nbmlaw from "@/apis/nbmlaw";
import ProceedButton from "@/components/ProceedButton";
export default {
  name: "Quotation",
  components: { Header, ProceedButton },
  data() {
    return {
      heading: null,
      quote: null,
      quoteProperties: null,
      quoteHtml: null
    };
  },
  methods: {
    async fetchQuote() {
      try {
        const response = await nbmlaw.get(
          `/cors/open/sales/quotes/${this.$route.params.quoteId}`,
          {
            params: { salesUid: this.$route.params.salesUid }
          }
        );
        // console.log(response.data);
        this.quote = response.data;
      } catch (err) {
        console.log(err);
        this.$router.push({ name: "notfound" });
      }
    },
    async fetchQuoteProperties() {
      try {
        const response = await nbmlaw.get(`/cors/open/sales/quoteProperties`);
        // console.log(response.data);
        this.quoteProperties = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchQuoteHtml() {
      const response = await nbmlaw.get(
        `/cors/open/sales/quotes/${this.$route.params.quoteId}/html`,
        {
          params: { salesUid: this.$route.params.salesUid }
        }
      );
      // console.log(response.data);
      this.quoteHtml = response.data;
    },
    async fetchHeading() {
      const response = await nbmlaw.get(
        `/cors/open/sales/quotes/${this.$route.params.quoteId}/heading`,
        {
          params: { salesUid: this.$route.params.salesUid }
        }
      );
      // console.log(response.data);
      this.heading = response.data;
    },
    proceed() {
      if (!this.quote) {
        return undefined;
      }
      if (this.quote.instructed != 1) {
        this.$router.push({
          name: "instruct",
          params: {
            salesUid: this.$route.params.salesUid,
            quoteId: this.$route.params.quoteId
          }
        });
      } else {
        this.$router.push({
          name: "instructionConfirmation",
          params: {
            salesUid: this.$route.params.salesUid,
            quoteId: this.$route.params.quoteId
          }
        });
      }
    },
    callback() {
      this.$router.push({
        name: "callback",
        params: {
          salesUid: this.$route.params.salesUid,
          quoteId: this.$route.params.quoteId
        }
      });
    }
  },
  created() {
    this.fetchQuote();
    this.fetchQuoteProperties();
    this.fetchQuoteHtml();
    this.fetchHeading();
  }
};
</script>

<style>
</style>